import axios from 'axios';
import {toast} from 'react-toastify';

axios.interceptors.response.use(null, error => {
    const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;
  
    if(!expectedError){
      console.log("Logging error: ",error);
      toast.error("An unexpected error accurred.");
    }
  
    return Promise.reject(error)
  });
  
  export default {
      get: axios.get,
      post: axios.post,
      put: axios.put,
      delete: axios.delete
  };